module.exports = __webpack_public_path__ + "static/kushimo-084ce01d07439edbe749358ad5061b78.png";